import { Accounts } from "app/utils/hyperlinkUtil";
import { FormattedMessage } from "react-intl";

export default function IdentityDocumentationText() {
  return (
    <label>
      <FormattedMessage tagName="span" id="home-register-over-18-years" />{" "}
      <a href={Accounts.IDENTITY_DOCUMENTS} target="_new">
        <FormattedMessage
          tagName="span"
          id="home-register-identity-documentation"
        />
      </a>{" "}
      <FormattedMessage tagName="span" id="home-register-fund-and-bet" />
    </label>
  );
}
